import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { TenantConfig, TenantInfo, TenantOrgOption, TenantTheme } from '../store/authSlice';
import { resolveApiOrigin } from '@vipso/shared';

export type ScopePayload = {
  scope: string;
  variantName: string;
  tenant: TenantInfo;
  config: TenantConfig | null;
  theme: TenantTheme;
  orgs: TenantOrgOption[];
};

/** Public unauthenticated scope bootstrap (REST). */
export const scopeApi = createApi({
  reducerPath: 'scopeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: resolveApiOrigin() || undefined,
  }),
  endpoints: (build) => ({
    getScope: build.query<ScopePayload, string>({
      query: (scope) => `/api/public/scope/${encodeURIComponent(scope)}`,
    }),
  }),
});

export const { useGetScopeQuery } = scopeApi;
